import { Link } from 'react-router-dom';
import { faBan, faLockKeyhole, faHourglassEnd } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RoomDescriptionProps } from '../../../../room.types';
import { StyledTitle } from '../../room-banner.styles';
export const RoomDescription = ({
  roomDetails,
  isBannedRoom,
  isPrivateRoom,
  isLockedRoom,
  isRetiredRoom,
  isSpecialOrPrivateRoom
}: RoomDescriptionProps) => <>
    <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="room-description.tsx">
      {isBannedRoom && <>
          <FontAwesomeIcon icon={faBan} />
          Banned room
        </>}
      {isPrivateRoom && <>
          <FontAwesomeIcon icon={faLockKeyhole} /> This room is private
        </>}
      {isLockedRoom && <>
          <FontAwesomeIcon icon={faLockKeyhole} /> Room is locked
        </>}
      {isRetiredRoom && <>
          <FontAwesomeIcon icon={faHourglassEnd} />
          Retired room
        </>}
      {!isSpecialOrPrivateRoom && roomDetails?.title}
    </StyledTitle>

    {isBannedRoom && <p>The room owner has banned you from this room, which means you cannot view any task content.</p>}

    {isLockedRoom && <p>The room owner has locked this room, which means you cannot view any task content.</p>}

    {isPrivateRoom && <p>Only users with the room link can access this room</p>}

    {isRetiredRoom && <p>
        This room has been retired. Please visit the <Link to="/hacktivities">learn page</Link> to find other great
        rooms to explore!
      </p>}
    {!isSpecialOrPrivateRoom && <p>{roomDetails?.description}</p>}
  </>;